/**
 * Sidebar.js - Chat History Sidebar Component
 * Displays conversation history, user profile, and navigation
 */

import React from 'react';
import { Icons } from './Icons';
import { getConversationTitle } from '../utils/storage';

function Sidebar({
  isOpen,
  onClose,
  conversations,
  activeConversationId,
  onNewChat,
  onSelectConversation,
  onDeleteConversation,
  onClearAllHistory,
  user,
  onLogout,
}) {
  return (
    <>
      {/* Sidebar Overlay (mobile) */}
      <div 
        className={`sidebar-overlay ${isOpen ? 'visible' : ''}`}
        onClick={onClose}
      />
      
      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img 
            src={`${process.env.PUBLIC_URL}/TAMC_LOGO%2BTL_H_WHITE.png`}
            alt="TAMC Logo" 
            className="sidebar-logo" 
          />
          <button className="new-chat-btn" onClick={onNewChat}>
            <Icons.Plus />
            <span>New Chat</span>
          </button>
        </div>
        
        <div className="chat-history">
          {conversations.length === 0 ? (
            <div className="chat-history-empty">
              No conversations yet
            </div>
          ) : (
            conversations.map(conv => (
              <div
                key={conv.id}
                className={`chat-history-item ${activeConversationId === conv.id ? 'active' : ''}`}
                onClick={() => onSelectConversation(conv.id)}
              >
                <Icons.Message />
                <span>{getConversationTitle(conv.messages)}</span>
                <button 
                  className="delete-btn"
                  onClick={(e) => onDeleteConversation(conv.id, e)}
                  title="Delete conversation"
                >
                  <Icons.Trash />
                </button>
              </div>
            ))
          )}
        </div>
        
        <div className="sidebar-footer">
          <button 
            className="clear-history-btn" 
            onClick={onClearAllHistory}
            title="Clear all chat history"
          >
            <Icons.Trash />
            <span>Clear All History</span>
          </button>
          <div className="user-profile">
            {user.picture ? (
              <img src={user.picture} alt={user.name} />
            ) : (
              <div className="user-avatar-fallback">
                {user.name?.charAt(0)?.toUpperCase() || user.email?.charAt(0)?.toUpperCase() || '?'}
              </div>
            )}
            <div className="user-profile-info">
              <div className="user-profile-name">{user.name}</div>
              <div className="user-profile-email">{user.email}</div>
            </div>
            <button 
              className="logout-btn" 
              onClick={onLogout}
              title="Logout"
            >
              <Icons.Logout />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;

